<div class="media-form container-fluid">

  <div class="alert alert-danger alert-dismissible fade show mb-4" *ngIf="errorMessage" role="alert">
    <div class="d-flex align-items-start">
      <mat-icon class="me-2">error</mat-icon>
      <div class="flex-grow-1">
        <strong>Error al procesar la imagen:</strong>
        <div class="mt-1">{{ errorMessage }}</div>
      </div>
      <button type="button" class="btn-close" (click)="errorMessage = null"></button>
    </div>
  </div>

  <div class="alert alert-info" *ngIf="isLoading">
    <mat-icon class="spinner">sync</mat-icon>
    <span class="ms-2">Subiendo imagen...</span>
  </div>

  <div class="row mb-4">

    <div class="col-md-4">
      <h6 class="fw-bold mb-3">Logo del Centro de Trabajo</h6>
      <div class="media-block h-100">

        <div class="media-preview logo-preview-container" *ngIf="logo">
          <img [src]="logo.preview" alt="Logo" class="logo-image">
          <div class="media-overlay">
            <app-button icon="delete" variant="danger" className="btn-sm" [disabled]="logoLoading"
              (click)="removeLogo()">
            </app-button>
          </div>
          <div class="loading-overlay" *ngIf="logoLoading">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          </div>
        </div>

        <div class="media-placeholder logo-placeholder" *ngIf="!logo">
          <mat-icon>image</mat-icon>
          <p>Sin logo</p>
        </div>

        <div class="media-actions">
          <input #logoInput type="file" hidden accept="image/*" (change)="onLogoSelected($event)">
          <app-button [label]="logo ? 'Reemplazar logo' : 'Subir logo'" icon="add" variant="primary"
            [disabled]="logoLoading" (click)="logoInput.click()">
          </app-button>
          <app-button *ngIf="logo" label="Eliminar" icon="delete" variant="danger" [disabled]="logoLoading"
            (click)="removeLogo()">
          </app-button>
        </div>
      </div>
    </div>

    <div class="col-md-8">
      <h6 class="fw-bold mb-3">Banner del Centro de Trabajo</h6>
      <div class="media-block h-100">

        <div class="media-preview banner-preview-container" *ngIf="banner">
          <img [src]="banner.preview" alt="Banner" class="banner-image">
          <div class="media-overlay">
            <app-button icon="delete" variant="danger" className="btn-sm" [disabled]="bannerLoading"
              (click)="removeBanner()">
            </app-button>
          </div>
          <div class="loading-overlay" *ngIf="bannerLoading">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          </div>
        </div>

        <div class="media-placeholder banner-placeholder" *ngIf="!banner">
          <mat-icon>image</mat-icon>
          <p>Sin banner</p>
        </div>

        <div class="media-actions">
          <input #bannerInput type="file" hidden accept="image/*" (change)="onBannerSelected($event)">
          <app-button [label]="banner ? 'Reemplazar banner' : 'Subir banner'" icon="add" variant="primary"
            [disabled]="bannerLoading" (click)="bannerInput.click()">
          </app-button>
          <app-button *ngIf="banner" label="Eliminar" icon="delete" variant="danger" [disabled]="bannerLoading"
            (click)="removeBanner()">
          </app-button>
        </div>
      </div>
    </div>

  </div>

  <div class="row mb-4">
    <div class="col-md-12">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h6 class="fw-bold mb-0">Carrusel de Imágenes</h6>
        <span class="carousel-counter" [class.carousel-limit]="carouselImages.length >= maxCarouselImages">
          {{ carouselImages.length }} / {{ maxCarouselImages }} imágenes
        </span>
      </div>
    </div>

    <div class="col-md-12">

      <div class="mb-3" *ngIf="canAddCarouselImages">
        <input #carouselInput type="file" hidden accept="image/*" multiple (change)="onCarouselSelected($event)">
        <app-button label="Añadir imágenes al carrusel" icon="add" variant="primary" [disabled]="carouselLoading"
          (click)="carouselInput.click()">
        </app-button>
      </div>

      <div class="carousel-grid" *ngIf="carouselImages.length > 0">
        <div class="carousel-item" *ngFor="let image of carouselImages; let i = index; trackBy: trackByIndex">
          <div class="carousel-image-container">
            <img [src]="image.preview" alt="Carousel image {{ i + 1 }}" class="carousel-image">
            <div class="carousel-overlay">
              <app-button icon="delete" variant="danger" className="btn-sm" [disabled]="carouselLoading"
                (click)="removeCarouselImage(i)">
              </app-button>
            </div>
            <div class="loading-overlay" *ngIf="carouselLoading">
              <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
            </div>
          </div>
          <div class="carousel-item-info">
            <span class="carousel-item-number">Imagen {{ i + 1 }}</span>
          </div>
        </div>
      </div>

      <div class="carousel-empty" *ngIf="carouselImages.length === 0">
        <mat-icon>photo_library</mat-icon>
        <p>No hay imágenes en el carrusel</p>
        <p class="text-muted">Puedes añadir hasta {{ maxCarouselImages }} imágenes</p>
      </div>

      <div class="alert alert-info mt-3" *ngIf="carouselImages.length >= maxCarouselImages">
        <mat-icon>info</mat-icon>
        <span>Has alcanzado el límite máximo de {{ maxCarouselImages }} imágenes en el carrusel</span>
      </div>
    </div>
  </div>

</div>